import { ExceptionDTO, RollingStock, } from '../../../models';
import { dateTimeService, transformToValidTrainCode } from '../../helpers/';
import { HttpResponse } from '../apiTemplate';
import ApiService from '../apiTemplate/api';

import {
	ApiRollingStockResponse,
	Count,
	RollingStockCode,
	RollingstockQuery,
	TrackingBoardDTO,
} from './rollingStock.api.types';

class RollingStockService extends ApiService {
	constructor() {
		super();
		this.endPoint = `${this.endPoint}/v1/rolling-stock`;
		this.credentials = 'include';
		this.setHeaders([
			{
				key: 'Accept',
				value: 'application/json',
			},
			{
				key: 'Content-Type',
				value: 'application/json',
			},
		]);
	}
	/**
	 * appel à l'api pour les matériels roulants
	 */
	public async loadRollingStock(
		searchedLine?: string
	): Promise<ApiRollingStockResponse> {
		this.setMethod('GET');
		const searchedLineType = searchedLine ? `?lineId=${searchedLine}` : '';
		try {
			const res = await fetch(
				`${this.endPoint}/services${searchedLineType}`,
				this.request()
			);
			const rawData = await res.text();

			return dateTimeService.parseJsonWithDateStrings<TrackingBoardDTO[]>(
				rawData
			);
		} catch (error) {
			throw new Error(`load rolling-stock information failed --> ${String(error)}`);
		}
	}

	/**
	 * appel à l'api pour les matériels roulants
	 */
	public async findOneRollingstock(
		query: RollingstockQuery
	): Promise<HttpResponse> {
		this.setMethod('GET');
		if (query.trainCode)
			query.trainCode = transformToValidTrainCode(query.trainCode);
		try {
			const res = await fetch(
				`${this.endPoint}/search${this.getSearchParams(query)}`,
				this.request()
			);
			const isOffline = res.status >= 500;
			return res.ok
				? { message: (await res.json()) as RollingStock, ok: true }
				: {
						isOffline,
						message: isOffline
							? 'offline'
							: ((await res.json()) as ExceptionDTO),
						ok: false,
				  };
		} catch {
			// Network or parsing error: treat as offline and return a safe fallback
			// rather than propagating the exception to the caller.
			return {
				isOffline: true,
				message: 'offline',
				ok: false,
			};
		}
	}

	/**
	 * load rolling stock lines
	 */
	public async loadLines(): Promise<Array<string>> {
		this.setMethod('GET');
		try {
			const res = await fetch(`${this.endPoint}/lines`, this.request());
			return await res.json();
		} catch (error) {
			throw new Error(`failed to get line list: ${String(error)}`);
		}
	}

	/**
	 * get
	 */
	public async getCountRollingStock(
		line?: string,
		department?: string
	): Promise<Count> {
		this.setMethod('GET');
		const lineType = line ?? `all${department}`;
		try {
			const res = await fetch(
				`${this.endPoint}/count/line/${lineType}`,
				this.request()
			);
			return (await res.json()) as Count;
		} catch (error) {
			throw new Error(`failed to get line list: ${String(error)}`);
		}
	}

	/**
	 * Get train codes
	 */
	public async getRollingStockCodes(line: string): Promise<RollingStockCode[]> {
		this.setMethod('GET');
		try {
			const res = await fetch(
				`${this.endPoint}/train-code/line/${line}`,
				this.request()
			);
			return (await res.json()) as RollingStockCode[];
		} catch (error) {
			throw new Error(`failed to get rolling stock codes: ${String(error)}`);
		}
	}
}
export const rollingStockService = new RollingStockService();

